<template>
    <v-dialog
      v-model="internalDialog"
      width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5"> <v-icon class="mr-2">mdi-magnify</v-icon>Rechecher</span>
        </v-card-title>
        <v-card-subtitle>
          Effectuez une recherche sur vos projects et vos conversations.
        </v-card-subtitle>
        <v-card-text>
          <v-text-field
            autofocus
            clearable
            v-model="searchQuery"
            label="Chercher"
            @click:clear="searchAll"
            @input="searchAll"
            class="ml-4"
            outlined
            dense
          ></v-text-field>
          <h6 v-if="results && results.length">{{ results.length }} résultats</h6>
          <v-list>
            <v-list-item
            v-for="(r, idx) in results" :key="idx" @click="goto(r)">
              <v-list-item-icon>
                <v-icon>{{ r.type === 'project' ? 'mdi-folder-text' : 'mdi-robot' }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content >
                <v-list-item-title>
                  <strong>{{ r.type === 'project' ? 'Projet' : 'Conversation' }}: </strong> {{ r.title }}
                  </v-list-item-title>
                <v-list-item-subtitle>
                  <div
                    v-for="(m, midx) in r.matches"
                    :key="midx"
                  >
                    ...<span v-html="highlight(m.snippet, searchQuery)"></span>...
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

export default {
  name: 'SearchDialog',
    props: {
      value: {
        type: Boolean,
        required: true  
      }
    },
    data: () => ({
      searchQuery: '',
      results: []
    }),
    computed: {
      internalDialog: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit("input", val)
        },
      },
  },
  methods: {
    extractSnippet(text, matchIndex, queryLength, radius = 40) {
      const start = Math.max(0, matchIndex - radius)
      const end = Math.min(text.length, matchIndex + queryLength + radius)

      return {
        snippet: text.slice(start, end),
        offset: start, // useful for highlight
      }
    },
    goto(result) {
      this.internalDialog = false;
      if (result.id == this.$route.params.id) return;
      const routeName = result.type === 'project' ? 'project_detail' : 'chat_detail'
      this.$router.push({ name: routeName, params: { id: result.id } })
    },
    highlight(text, query) {
      if (!query) return text
      const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
      const regex = new RegExp(`(${escaped})`, "gi")
      return text.replace(regex, "<mark>$1</mark>")
    },
    searchAll() {
      const query = this.searchQuery || ''
      if (!query.trim()) {
        this.results = []
        return
      }

      const normalize = str => str.toLowerCase()
      const q = normalize(query)
      const results = []

      // Search projects
      for (const proj of this.$store.state.project.projects) {
        const matches = []
        for (const [field, text] of [['title', proj.title], ['domain', proj.domain], ['initial_message', proj.initial_message]]) {
          if (!text) continue
          const norm = normalize(text)
          let pos = norm.indexOf(q)
          if (pos !== -1) {
            matches.push({ source: field, ...this.extractSnippet(text, pos, query.length) })
          }
        }
        if (matches.length) {
          results.push({ type: 'project', id: proj.id, title: proj.title, matches })
        }
      }

      // Search conversations
      for (const conv of this.$store.state.chat.conversations) {
        const matches = []
        const titleNorm = normalize(conv.title)
        const titleIdx = titleNorm.indexOf(q)
        if (titleIdx !== -1) {
          matches.push({ source: 'title', ...this.extractSnippet(conv.title, titleIdx, query.length) })
        }
        for (const msg of conv.messages || []) {
          const contentNorm = normalize(msg.content)
          let pos = 0
          while ((pos = contentNorm.indexOf(q, pos)) !== -1) {
            matches.push({ source: 'message', role: msg.role, ...this.extractSnippet(msg.content, pos, query.length) })
            pos += q.length
          }
        }
        if (matches.length) {
          results.push({ type: 'conversation', id: conv.id, title: conv.title, matches })
        }
      }

      this.results = results
    }
    },
  }
</script>